'use client'

import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { TENANT_TYPE } from '@components/Ackodrive/common/constants'
import { EVENTS } from '@configs/events.config'
import styles from './DownloadButton.module.scss'

const DownloadButton = ({
  url,
  ctaText,
  newPage = false,
  journey,
}: {
  url: string
  ctaText: string
  newPage?: boolean
  journey: string
}) => {
  const handleClick = async () => {
    await trackEvent(EVENTS[TENANT_TYPE.MEDIAKIT].engage.eventname, {
      ...EVENTS[TENANT_TYPE.MEDIAKIT].engage.eventProps,
      journey,
    })
  }
  return (
    <a
      className={styles.aboutAckoLink}
      href={url}
      target={newPage ? '_blank' : '_self'}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={handleClick}>
      {ctaText}
    </a>
  )
}

export default DownloadButton
